import React, { useEffect, useState } from "react";
import { history, useModel } from "@umijs/max";
import { Space, Popover, Form, Input, message, Select } from "antd";
import { LogoutOutlined, SettingOutlined } from "@ant-design/icons";
import picBoard from "@/assets/img/board.png";
import CustomModal from "@/components/CustomModal";
import { changePasswordApi } from "@/services/http/auth";
import {
  filterMenusByMainMenu,
  findFirstVisibleMenuPath,
  getMainMenuByPath,
  MAIN_MENU_OPTIONS,
  type MainMenuKey,
} from "@/utils/mainMenu";
import { useRou } from "@/utils/rou";
import routes from "../../../config/routes";
import defaultSettings from "../../../config/defaultSettings";
import "./index.less";
import {
  lastMonthReportApi,
  todayReportStatusApi,
  reportHistoryByGenerateBatchIdApi,
} from "@/services/http/resiBatchRecord";
import { autoReportConfigApi } from "@/services/http/resiReportStrategy";
import dayjs from "dayjs";
import EmptyState from "@/components/EmptyState";
interface HeaderProps {
  collapsed?: boolean;
  onCollapse?: (collapsed: boolean) => void;
  currentUser?: any;
}
const callRou = useRou();

const Header: React.FC<HeaderProps> = ({
  collapsed = false,
  onCollapse,
  currentUser,
}) => {
  const [form] = Form.useForm();
  const [changePasswordModalVisible, setChangePasswordModalVisible] =
    useState(false);
  const [changePasswordLoading, setChangePasswordLoading] = useState(false);

  // 处理logo点击事件
  const handleLogoClick = async () => {
    const routerObj: any = await callRou.getHome();
    if (routerObj) {
      history.push(routerObj.path);
    }
  };
  //有效菜单
  const [valiableMainMenu, setValiableMainMenu] = useState<{}[]>([]);
  useEffect(() => {
    const menuCode = callRou.getTopFlatCodes();
    const valiableMainMenuN = MAIN_MENU_OPTIONS.filter((item: any) =>
      menuCode.includes(item.code),
    );
    setValiableMainMenu(valiableMainMenuN);
  }, []);
  // 打开修改密码弹窗
  const handleChangePasswordClick = () => {
    setChangePasswordModalVisible(true);
    form.resetFields();
  };

  // 关闭修改密码弹窗
  const handleCloseChangePasswordModal = () => {
    setChangePasswordModalVisible(false);
    form.resetFields();
  };

  // 提交修改密码
  const handleChangePasswordSubmit = async () => {
    try {
      const values = await form.validateFields();
      setChangePasswordLoading(true);

      await changePasswordApi({
        oldPassword: values.oldPassword,
        newPassword: values.newPassword,
        confirmPassword: values.confirmPassword,
      });

      message.success("密码修改成功，请重新登录");
      setChangePasswordLoading(false);
      setChangePasswordModalVisible(false);
      form.resetFields();

      // 退出登录
      setTimeout(() => {
        callRou.logout();
      }, 1000);
    } catch (error: any) {
      setChangePasswordLoading(false);
      if (error?.errorFields) {
        // 表单验证错误，不处理
        return;
      }
    }
  };

  const { activeMainMenu, setActiveMainMenu } = useModel("menuModel");
  const { updateGlobalData, globalData } = useModel("contactModel");
  const firstLetter = (currentUser?.name || "unknown").split("")[0];

  //======================================== 主菜单 ====================================
  const handleMainMenuSwitch = (key: MainMenuKey) => {
    if (key === activeMainMenu) {
      return;
    }
    setActiveMainMenu(key);
    const menuWithPermission = callRou.getHasMenu(routes as any[]);
    const filteredMenu = filterMenusByMainMenu(menuWithPermission, key);
    const firstMenuPath = findFirstVisibleMenuPath(filteredMenu);
    if (firstMenuPath) {
      history.push(firstMenuPath);
    }
  };
  const content = (
    <div style={{ padding: "0px 10px", minWidth: "200px" }}>
      {/* 用户信息区域 */}
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginBottom: "16px",
        }}
      >
        <div
          style={{
            width: "48px",
            height: "48px",
            borderRadius: "50%",
            backgroundColor: "var(--ant-color-primary)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "12px",
            flexShrink: 0,
          }}
        >
          <span
            style={{
              color: "#fff",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            {firstLetter}
          </span>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div
            style={{
              fontSize: "16px",
              fontWeight: 500,
              color: "#333333",
              marginBottom: "4px",
            }}
          >
            {currentUser?.name || "用户"}
          </div>
          <div
            style={{
              fontSize: "14px",
              color: "#666666",
            }}
          >
            {currentUser?.phone || currentUser?.mobile || ""}
          </div>
        </div>
      </div>

      {/* 分隔线 */}
      <div
        style={{
          borderBottom: "1px solid #E0E0E0",
          marginBottom: "8px",
        }}
      />

      {/* 操作按钮区域 */}
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          onClick={handleChangePasswordClick}
          style={{
            display: "flex",
            alignItems: "center",
            padding: "12px 0",
            cursor: "pointer",
            transition: "color 0.2s",
            color: "#333333",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = "#009040";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = "#333333";
          }}
        >
          <SettingOutlined style={{ marginRight: "8px", fontSize: "16px" }} />
          <span style={{ fontSize: "15px" }}>修改密码</span>
        </div>

        <div
          onClick={() => {
            callRou.logout();
          }}
          style={{
            display: "flex",
            alignItems: "center",
            padding: "12px 0",
            cursor: "pointer",
            transition: "color 0.2s",
            color: "#333333",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = "#009040";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = "#333333";
          }}
        >
          <LogoutOutlined style={{ marginRight: "8px", fontSize: "16px" }} />
          <span style={{ fontSize: "15px" }}>退出登录</span>
        </div>
      </div>
    </div>
  );
  //==================================== 监测菜单地址 ====================================
  const [latestUrl, setLatestUrl] = useState<string>("");

  const getLatestUrl = () => {
    const location = history.location;
    setLatestUrl(location.pathname); 
  };

  useEffect(() => {
    getLatestUrl();
  }, [history.location]);
  //======================================== 报告配置 ====================================
  const [reportConfigOptions, setReportConfigOptions] = useState<any[]>([]);
  const [currentConfig, setCurrentConfig] = useState<any>({
    value: "",
    label: "",
    lastReportTime: "",
    finalResultText: "",
  });
  const getLastMonthReport = async () => {
    try {
      const res = await lastMonthReportApi({});
      const result = res.data.map((item: any) => ({
        ...item,
        label: `上报数据：${item.reportDataRange}    最后上报时间：${item.lastReportTime}    最后上报结果：${item.finalResultText}`,
        value: item.id,
      }));
      setReportConfigOptions(result);
      if (result.length > 0) {
        setCurrentConfig(result[0]);
        updateGlobalData({ reportCurrentConfig: result[0] || null });
      }
    } catch (error) {
      console.log(error);
    }
  };
  const changeCurrentConfig = (value: any) => {
    if (value) {
      const item = reportConfigOptions.find(
        (option: any) => option.value === value,
      );
      setCurrentConfig(item);
      updateGlobalData({ reportCurrentConfig: item || null });
    } else {
      setCurrentConfig("");
      updateGlobalData({ reportCurrentConfig: null });
    }
  };

  //下次下报时间
  const [nextReportTime, setNextReportTime] = useState<string>("");
  const getAutoReportConfig = async () => {
    try {
      const res = await autoReportConfigApi();
      setNextReportTime(res.data?.autoReportTime || "");

      getLastMonthReport();
    } catch (error) {
      console.log(error);
    }
  };
  //今日已上报数据
  const [todayReportStatus, setTodayReportStatus] = useState<any>({});
  const getTodayReportStatus = async () => {
    try {
      const res = await todayReportStatusApi({});
      setTodayReportStatus(res.data || {});
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getTodayReportStatus();
    getAutoReportConfig();
  }, [globalData.todayReportStatus]);
  //===============获取历史批次上报记录=====================
  const [historyList, setHistoryList] = useState<any[]>([]);
  const getReportHistoryByGenerateBatchId = async () => {
    const params = {
      generateBatchId: currentConfig?.value || "",
    };
    if (!params.generateBatchId) {
      return;
    }
    try {
      const res = await reportHistoryByGenerateBatchIdApi(params);
      setHistoryList(res.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getReportHistoryByGenerateBatchId();
  }, [currentConfig]);
  const contentDom = (
    <div style={{ width: 660, padding: "4px 0", color: "#334155" }}>
      <div
        style={{
          fontSize: 14,
          lineHeight: "21px",
          color: "#009040",
          fontWeight: 600,
          marginBottom: 18,
        }}
      >
        上报数据：{currentConfig?.reportDataRange || "--"}
      </div>

      {historyList.map((item: any, index: number) => (
        <div
          key={item.id || index}
          style={{ marginBottom: index === historyList.length - 1 ? 0 : 14 }}
        >
          <div
            style={{
              fontSize: 12,
              lineHeight: "18px",
              color: "#1e293b",
              fontWeight: 500,
              marginBottom: 10,
            }}
          >
            上报历史次数{historyList.length - index}
          </div>
          <div
            style={{
              fontSize: 12,
              lineHeight: "18px",
              color: "#64748b",
              borderTop: "1px solid #eef2f7",
              paddingTop: 8,
            }}
          >
            上报数据:{item?.reportDataRange || "--"} 最后上报时间:
            {item?.lastReportTime || "--"}
            最后上报结果:{item?.finalResultText || "--"}
          </div>
        </div>
      ))}

      {historyList.length === 0 && (
        <div style={{ fontSize: 12, lineHeight: "18px", color: "#94a3b8" }}>
          暂无上报历史
        </div>
      )}
    </div>
  );
  useEffect(() => {
    getAutoReportConfig();
    getTodayReportStatus();
  }, []);
  return (
    <div className="custom-header" data-url={latestUrl}>
      <div className="header-left">
        <div className="logo" onClick={handleLogoClick}>
          <img src={defaultSettings.logo} alt="logo" />
          {!collapsed && <span className="title">{defaultSettings.title}</span>}
        </div>
      </div>
      <div className="top-menu">
        {valiableMainMenu.map((item: any) => (
          <div
            key={item.key}
            className={`menu-item ${activeMainMenu === item.key ? "active" : ""}`}
            onClick={() => handleMainMenuSwitch(item.key)}
          >
            {item.name}
          </div>
        ))}
      </div>
      {activeMainMenu === "resident" && (
        <div className="header-reportConfig">
          <Space>
            {latestUrl === "/data-reporting/pending-report-data" && (
              <Select
                options={reportConfigOptions}
                style={{ width: 220 }}
                value={currentConfig?.value || ""}
                onChange={(value) => changeCurrentConfig(value)}
                placeholder="请选择接口"
              />
            )}
            {!currentConfig?.lastReportTime && (
              <span>下次自动上报时间：{nextReportTime || "--"}</span>
            )}
            {currentConfig?.lastReportTime  && (
              <Popover content={latestUrl === "/data-reporting/pending-report-data" ? contentDom : null} title={null}>
                <span>最后上报时间：{currentConfig?.lastReportTime || ""}</span>
              </Popover>
            )} 
            {todayReportStatus?.reportStatus > 0 && (
              <span>
                {todayReportStatus?.reportStatus == 1
                  ? "今日未上报"
                  : "今日已上报"}{" "}
              </span>
            )}
          </Space>
        </div>
      )}
      <div className="header-right">
        <Space size="middle" wrap>
          <a href="/data-view" target="_blank">
            <img src={picBoard} />{" "}
          </a>
          {/* 用户头像和下拉菜单 */}
          <Popover content={content} placement="bottomRight" arrow>
            <div className="avatar-container">
              <span className="avatar-container-first-letter">
                {firstLetter}
              </span>
            </div>
          </Popover>
        </Space>
      </div>

      {/* 修改密码弹窗 */}
      <CustomModal
        title="修改密码"
        open={changePasswordModalVisible}
        onOk={handleChangePasswordSubmit}
        onCancel={handleCloseChangePasswordModal}
        confirmLoading={changePasswordLoading}
        okText="确认提交"
        cancelText="取消"
        width={400}
        centered
      >
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          style={{ padding: "8px 0" }}
        >
          <Form.Item
            label={<span style={{ color: "#555555" }}>原密码</span>}
            name="oldPassword"
            rules={[
              { required: true, message: "请输入原密码" },
              { min: 6, message: "密码长度不能少于6位" },
            ]}
            validateTrigger="onBlur"
          >
            <Input.Password
              placeholder="请输入原密码"
              style={{ height: "44px" }}
            />
          </Form.Item>

          <Form.Item
            label={<span style={{ color: "#555555" }}>新密码</span>}
            name="newPassword"
            rules={[
              { required: true, message: "请输入新密码" },
              { min: 6, message: "密码长度不能少于6位" },
            ]}
            validateTrigger="onBlur"
          >
            <Input.Password
              placeholder="请输入新密码"
              style={{ height: "44px" }}
            />
          </Form.Item>

          <Form.Item
            label={<span style={{ color: "#555555" }}>确认密码</span>}
            name="confirmPassword"
            dependencies={["newPassword"]}
            rules={[{ required: true, message: "请再次输入新密码" }]}
            validateTrigger="onBlur"
          >
            <Input.Password
              placeholder="请再次输入新密码"
              style={{ height: "44px" }}
            />
          </Form.Item>
        </Form>
      </CustomModal>
    </div>
  );
};

export default Header;
